import { Controller } from "@hotwired/stimulus"

// Fills hidden latitude/longitude fields with the device's location so the
// server can verify the customer is physically at the diner (geofence gate).
// Disables the submit button until a fix is obtained.
export default class extends Controller {
  static targets = ["latitude", "longitude", "submit", "status"]

  connect() {
    if (!("geolocation" in navigator)) {
      this.setStatus("Location isn't supported on this device.")
      return
    }

    this.locate()
  }

  locate() {
    this.disableSubmit()
    this.setStatus("Getting your location…")

    navigator.geolocation.getCurrentPosition(
      (position) => this.onSuccess(position),
      (error) => this.onError(error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    )
  }

  onSuccess(position) {
    if (this.hasLatitudeTarget) {
      this.latitudeTarget.value = position.coords.latitude
    }
    if (this.hasLongitudeTarget) {
      this.longitudeTarget.value = position.coords.longitude
    }
    this.enableSubmit()
    this.setStatus("Location confirmed.")
  }

  onError() {
    this.enableSubmit()
    this.setStatus("Couldn't get your location. Please enable location access and retry.")
  }

  disableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }
  }

  setStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }
}
